import { motion } from "framer-motion";
import { ChevronDown, MapPin } from "lucide-react";
import { stripHtml } from "@/lib/text";
import { ekkoText } from "@/lib/ekkoDefaults";
import { whatsappLink } from "@/lib/whatsapp";

const ENTER = (delay) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
});

// Topo em ecrã inteiro (disposição da Durius) com os textos e a foto da EKKO
export default function HeroSection({ content = {}, priceFrom = "" }) {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  const image = ekkoText(content, "hero_background_image");

  return (
    <section id="hero" className="relative h-[85vh] min-h-[560px] flex items-center justify-center overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0 z-0">
        <img src={image} alt={ekkoText(content, "hero_image_alt")} className="w-full h-full object-cover" fetchpriority="high" />
        <div className="hero-overlay absolute inset-0" />
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <motion.span {...ENTER(0.1)} className="inline-flex items-center gap-2 bg-[#A6C48A] text-[#010000] px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-[0.12em] mb-6">
          <MapPin size={14} /> {ekkoText(content, "hero_badge")}
        </motion.span>

        <motion.h1
          {...ENTER(0.2)}
          className="text-4xl sm:text-5xl md:text-6xl font-bold text-white leading-[1.05] mb-6 rich-text-content"
          data-testid="hero-title"
          dangerouslySetInnerHTML={{ __html: ekkoText(content, "hero_title") }}
        />

        <motion.div
          {...ENTER(0.3)}
          className="text-base md:text-lg text-white/85 mb-10 max-w-2xl mx-auto rich-text-content"
          data-testid="hero-subtitle"
          dangerouslySetInnerHTML={{ __html: ekkoText(content, "hero_subtitle") }}
        />

        <motion.div {...ENTER(0.4)} className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollTo("#contacto")}
            className="btn-skew bg-[#A6C48A] text-[#010000] px-8 py-4 font-bold text-base uppercase tracking-wider hover:bg-[#B9D3A1]"
            data-testid="hero-cta-primary"
          >
            <span>{stripHtml(ekkoText(content, "hero_button_primary"))}</span>
          </button>
          <a
            href={whatsappLink(content, "Olá! Gostava de saber mais sobre o EKKO Fitness Center.")}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-skew border-2 border-[#A6C48A] text-[#A6C48A] px-8 py-4 font-bold text-base uppercase tracking-wider hover:bg-[#A6C48A] hover:text-[#010000] transition-colors"
            data-testid="hero-cta-secondary"
          >
            <span>{stripHtml(ekkoText(content, "hero_button_secondary"))}</span>
          </a>
        </motion.div>

        {stripHtml(priceFrom) && (
          <motion.p {...ENTER(0.5)} className="mt-6 text-white/85 text-sm tracking-wide">
            Planos a partir de <strong className="text-white">{stripHtml(priceFrom)}</strong>
          </motion.p>
        )}
      </div>

      <motion.button
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.6 }}
        onClick={() => scrollTo("#pilares")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white animate-bounce"
        aria-label="Descer para o conteúdo"
      >
        <ChevronDown size={32} />
      </motion.button>
    </section>
  );
}
